import { connect } from 'react-redux';
import ProjectRow from './ProjectRow';
// import { projectStatusLoading } from '../../../../../store/selectors/projecte.selector';
import { sortProjectRequest, updateProjectFlag } from '../../../../../store/actions/projects.actions';

const mapDispatchToProps = { 
    sortProjectRequest,
    updateFlag: updateProjectFlag
};

const mapStateToProps = (state) => { 
    // const statusLoading = updateProjectStatus(state);

    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ProjectRow);